import HeaderAIChatbot from '~/layouts/components/HeaderAIChatbot';
import 'react-toastify/dist/ReactToastify.css';
import {Fragment} from "react";
function AIChatbotLayout({children })  {
    return (
        <main className='main'>
            <HeaderAIChatbot />
            <div className='content container-medium'>{children}</div>
        </main>
    )
}
export default AIChatbotLayout;